import React from "react";
import "../ECommerce/ECommerce.css";
import "../Page.css";
import axios from "axios";
import { security_key, Url } from "../../Services/Api";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import actionIcon from "../../Assets/Images/ActionBtn 30 x 30.png";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { useState, useEffect, useRef } from "react";
import { formatOrderDate } from "../../Components/UI-Controls/DateFormat/DateFormat";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import ElipticalPagenation from "../../Components/UI-Controls/Pagination/Pagination2";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import { IoEyeOutline } from "react-icons/io5";
import InputField from "../../Components/UI-Controls/InputField/InputField";
import BottomToust from "../../Components/BottomToust/BottomToust";
import { CiWarning } from "react-icons/ci";
import { Tooltip } from 'antd';
import { DatePicker } from "antd";
import CustomDropdown from "../../Components/UI-Controls/Dropdown/dropdown";
import AddBlogSEO from "../ECommerce/SEO/AddBlogSEO";
import ImageGalleryPopup from "../../Components/UI-Controls/PopUp/ImageGalleryPapup/ImageGalleryPopup";


const AllBlogs = () => {

  const { RangePicker } = DatePicker;

  const disabledDate = (current) => {
    return current && current > new Date();
  };

  const rowsPerPage = 10;
  const navigate = useNavigate();
  const modalRef = useRef(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [dateRange, setDateRange] = useState(null);

  // --- New Filter States: Title Search, Published Date Range, Status ---
  const [searchTitle, setSearchTitle] = useState("");
  const [status, setStatus] = useState(null);
  const [filterLoading, setFilterLoading] = useState(false);

  const [filtersModified, setFiltersModified] = useState(false);
  const [filteredData, setFilteredData] = useState(data);
  const [showMessage, setShowMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [currentRowId, setCurrentRowId] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [error, setError] = useState(null);
  const [totalPages, setTotalPages] = useState(null);

  const [showSeoDrawer, setShowSeoDrawer] = useState(false);
  const [modalView, setModalView] = useState(false);
  const [modaldata, setModalData] = useState([]);

  const [metaData, setMetaData] = useState({
    metaTitle: "",
    metaDescription: "",
    metaKeywords: "",
    canonicalUrl: "",
    robots: "",
    ogTitle: "",
    ogDescription: "",
    og_image: "",
    xTitle: "",
    xDescription: "",
    x_image: "",
    schemaMarkup: "",
  });




  const statusOptions = [
    { value: "draft", label: "Draft" },
    { value: "published", label: "Published" },
  ];

  useEffect(() => {
    fetchBlogsData(currentPage);
  }, [currentPage]);

  const timeZone = "America/New_York";

  /* --- Builds the query string for the blogs API.
     `overrides` lets a caller pass explicit filter values instead of relying on
     current React state — needed because state setters are async, so a reset
     that clears state and fetches in the same breath would otherwise still
     read the stale (pre-reset) values from the closure. --- */
  const buildBlogsQueryParams = (page, overrides = {}) => {
    const params = new URLSearchParams();
    params.append("page", page);

    const effectiveSearch = Object.prototype.hasOwnProperty.call(overrides, "searchTitle")
      ? overrides.searchTitle
      : searchTitle;
    const effectiveStatus = Object.prototype.hasOwnProperty.call(overrides, "status")
      ? overrides.status
      : status;
    const effectiveDateRange = Object.prototype.hasOwnProperty.call(overrides, "dateRange")
      ? overrides.dateRange
      : dateRange;

    if (effectiveSearch) {
      params.append("search", effectiveSearch);
    }

    if (effectiveDateRange && effectiveDateRange.length === 2 && effectiveDateRange[0] && effectiveDateRange[1]) {
      const fromDate = effectiveDateRange[0]?.format ? effectiveDateRange[0].format("YYYY-MM-DD") : effectiveDateRange[0];
      const toDate = effectiveDateRange[1]?.format ? effectiveDateRange[1].format("YYYY-MM-DD") : effectiveDateRange[1];
      params.append("publishedDateFrom", fromDate);
      params.append("publishedDateTo", toDate);
    }

    if (effectiveStatus) {
      params.append("status", effectiveStatus);
    }

    params.append("sortBy", "publishedDate");

    return params.toString();
  };

  const fetchBlogsData = async (page = 1, overrides = {}) => {
    setLoading(true);
    setError(null);
    setTimeout(async () => {
      try {
        const queryParams = buildBlogsQueryParams(page, overrides);
        const response = await axios.get(`${Url}/api/v1/blogs/get?order=desc&${queryParams}`);
        const allBlogs = response.data.blogs || [];
        const reversedData = allBlogs;
        setData(reversedData);
        setFilteredData(reversedData);
        setToastMessage("Blogs Data have been fetched successfully!");
        setShowMessage(true);
        setTotalPages(response.data?.totalPages)
      } catch (error) {
        const errMsg = error?.response?.data?.message || error.message;
        setError(errMsg);
        setToastMessage(`Failed to fetch Blogs Data: ${errMsg}`);
        setShowMessage(true);
      } finally {
        setLoading(false);
        setFilterLoading(false);
      }
    }, 2000);
  };

  const handleCloseMessageModal = () => {
    setShowMessage(false);
  };

  useEffect(() => {
    if (showMessage === true) {
      const timeOut = setTimeout(() => {
        setShowMessage(false);
      }, 3000);

      return () => clearTimeout(timeOut);
    }
  }, [showMessage]);

  const customStyles = {
    headCells: {
      style: {
        height: "clamp(50px, 5vw, 56px)",
        background: "transparent",
        opacity: "1",
        textAlign: "center",
        justifyContent: "center",
        border: "none",
        color: "var(--text-color-1)",
        fontFamily: "var(--font-family)",
        fontWeight: "var(--font-weight-medium)",
        fontSize: "clamp(var(--font-size-medium), 0.8vw, calc(var(--font-size-medium) + 2px))",
      },
    },
    cells: {
      style: {
        height: "clamp(50px, 6vw, 66px)",
        justifyContent: "center",
        textAlign: "center",
        background: "transparent",
        borderTop: "var(--standered-border)",
        borderRight: "none",
        color: "var(--text-color-1)",
        fontFamily: "var(--font-family)",
        fontWeight: "var(--font-weight-regular)",
        fontSize: "clamp(var(--font-size-small), 0.8vw, calc(var(--font-size-small) + 2px))",
      },
    },
  };

  const toggleDropdown = (id) => {
    setOpenDropdownId((prevId) => (prevId === id ? null : id));
  };

  const [selectedRow, setSelectedRow] = useState(null);

  const handleAction = (action, row) => {
    console.log(`Action: ${action} triggered for row:`, row);
    switch (action) {
      case "view":
        handleView(row);
        setOpenDropdownId(null);
        break;

      case "render":
        handleRenderedView(row);
        setOpenDropdownId(null);
        break;
      case "edit":
        handleEdit(row);
        setOpenDropdownId(null);
        break;
      case "manage-seo":
        setOpenDropdownId(null);
        setShowSeoDrawer(true);
        setMetaData({
          metaTitle: row?.meta?.title,
          metaDescription: row?.meta?.description,
          metaKeywords: row?.meta?.keywords,
          ogTitle: row?.meta?.og_title,
          ogDescription: row?.meta?.og_description,
          xTitle: row?.meta?.x_title,
          xDescription: row?.meta?.x_description
        });
        console.log(row)
        setSelectedRow(row);

        break;
      case "delete":
        confirmDelete(row);
        setOpenDropdownId(null);
        break;
      default:
        break;
    }
  };

  const confirmDelete = (row) => {
    setCurrentRowId(row._id);
    setShowConfirm(true);
  };

  const cancelDelete = () => {
    setShowConfirm(false);
  };

  const handleDelete = () => {
    if (currentRowId) {
      deleteItem(currentRowId);
    }
  };

  const deleteItem = async (id) => {
    setIsLoading(true);
    setIsActive(true);

    const token = sessionStorage.getItem('authToken');
    const headers = {
      Authorization: `Bearer ${token}`,
      'x-api-key': security_key
    };

    try {
      let successMessage = "Blog deleted successfully!";

      const response = await fetch(`${Url}/api/v1/blogs/delete/${id}`, {
        method: "DELETE",
        headers
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const responseData = await response.json();
      setData((prevItems) => prevItems.filter((item) => item._id !== id));
      setToastMessage(successMessage);
      setShowMessage(true);
      fetchBlogsData(currentPage);
    } catch (error) {
      let errorMessage = "Failed to delete the selection. Please try again.";
      console.error("Error deleting item:", error);
      setToastMessage(errorMessage);
      setShowMessage(true);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        setIsActive(false);
      }, 5000);
      setShowConfirm(false);
    }
  };

  /* --- Function to Handle Display of Confirmation Dialogue Box of Delete Action --- */
  const handleDeleteClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      cancelDelete();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleDeleteClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleDeleteClickOutside);
    };
  }, []);

  const handleEdit = (row) => {
    navigate((`/Blogs/Edit-Blog/${row._id}`), { state: { blog_Data: row } });
  };

  const handleView = (row) => {
    navigate((`/Blogs/View-Blog/${row._id}`), { state: { view_Data: row } });
  };

  const handleRenderedView = (row) => {
    navigate((`/Blogs/Quick-View/${row._id}`), { state: row });
  };

  const handleClickOutside = (event) => {
    if (
      !event.target.closest(".dropdown-menu") &&
      !event.target.closest(".bar-icon")
    ) {
      setOpenDropdownId(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const BlogsColumns = [
    {
      name: (
        <input
          type="checkbox"
          style={{ margin: 0 }}
          onChange={(e) => console.log("All selected:", e.target.checked)}
        />
      ),
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="20px" height="22px" />
        ) : (
          <input
            type="checkbox"
            style={{ margin: 0 }}
            onChange={(e) => console.log("Selected:", row, e.target.checked)}
          />
        ),
      ignoreRowClick: true,
      width: "50px",
    },
    {
      name: "Date",
      selector: (row) => {
        if (loading) {
          return (
            <ShimmerLoader width="120px" height="22.5px" borderRadius="20px" />
          );
        }

        const { formattedDate, hoursAgo, showYesterday } = formatOrderDate(
          row.publishedDate
        );

        return hoursAgo
          ? hoursAgo
          : showYesterday
            ? "Yesterday"
            : formattedDate;
      },
      minWidth: "115px",
      maxWidth: "175px",
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="120px" height="22.5px" borderRadius="20px" />
        ) : (
          <div
            style={{
              whiteSpace: "normal",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              maxHeight: "44px",
            }}
          >
            {(() => {
              const { formattedDate, hoursAgo, showYesterday } =
                formatOrderDate(row.publishedDate);
              return hoursAgo
                ? hoursAgo
                : showYesterday
                  ? "Yesterday"
                  : formattedDate;
            })()}
          </div>
        ),
    },
    {
      name: "Title",
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="200px" height="22.5px" borderRadius="20px" />
        ) : (
          <Tooltip title={row.title}>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
              }}
            >
              {row.title}
            </div>
          </Tooltip>
        ),
      minWidth: "280px",
      maxWidth: "400px",
    },
    {
      name: "Author",
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="200px" height="22.5px" borderRadius="20px" />
        ) : (
          <div>{row.author}</div>
        ),
      minWidth: "120px",
      maxWidth: "200px",
    },
    {
      name: "Category",
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="200px" height="22.5px" borderRadius="20px" />
        ) : (
          <div>{row?.category?.name || "No Category"}</div>
        ),
      minWidth: "175px",
      maxWidth: "200px",
    },
    {
      name: "Status",
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="120px" height="22.5px" borderRadius="20px" />
        ) : (
          (() => {
            let textColor;
            let bgColor;
            let displayText;

            if (row.status === "published") {
              displayText = "Published";
              textColor = "#5285B4";
              bgColor = "transparent";
            } else {
              displayText = "Draft";
              textColor = "#595959";
              bgColor = "transparent";
            }

            return (
              <div
                style={{
                  color: textColor,
                  backgroundColor: bgColor,
                  padding: "5px 10px",
                  borderRadius: "5px",
                  display: "inline-block",
                  fontWeight: 600,
                }}
              >
                {displayText}
              </div>
            );
          })()
        ),
      minWidth: "130px",
      maxWidth: "180px",
    },
    // {
    //   name: "Tag",
    //   selector: (row) =>
    //     !loading ? (
    //       row.tags && row.tags.length > 0 ? (
    //         <Tooltip
    //           title={row.tags.length > 2 ? row.tags.slice(2).join(", ") : ""}
    //         >
    //           <div>
    //             {row.tags.slice(0, 2).map((tag, index) => (
    //               <span key={index} style={{ display: "block" }}>
    //                 {tag}
    //               </span>
    //             ))}
    //             {row.tags.length > 2 && <span style={{ color: 'var(--active-element-color)', fontWeight: 'var(--font-weight-semi-bold)' }}>+{row.tags.length - 2} more</span>}
    //           </div>
    //         </Tooltip>
    //       ) : (
    //         "N/A"
    //       )
    //     ) : (
    //       <ShimmerLoader width="80px" height="22.5px" borderRadius="20px" />
    //     ),
    //   minWidth: "175px",
    //   maxWidth: "250px",
    // },
    {
      name: "Action",
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="60px" height="22.5px" />
        ) : (
          <div style={{ position: "relative" }}>
            <img
              src={actionIcon}
              alt="Action Icon"
              width="40"
              height="40"
              style={{ cursor: "pointer", margin: 0, padding: 0 }}
              className={`bar-icon ${openDropdownId === row._id ? "rotated" : ""
                }`}
              onClick={() => toggleDropdown(row._id)}
            />
            {openDropdownId === row._id && (
              <div className={`dropdown-menu show animate-dropdown-left`}>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  <li
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "5px 10px",
                      border: "none",
                    }}
                    onClick={() => handleAction("view", row)}
                  >
                    <IoEyeOutline style={{ marginRight: "12px" }} className="icon-img-updated" />
                    View
                  </li>
                  <li
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "5px 10px",
                      border: "none",
                    }}
                    onClick={() => handleAction("render", row)}
                  >
                    <IoEyeOutline style={{ marginRight: "12px" }} className="icon-img-updated" />
                    Quick View
                  </li>
                  <li
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "5px 10px",
                      border: "none",
                    }}
                    onClick={() => handleAction("edit", row)}
                  >
                    <FiEdit style={{ marginRight: "12px" }} className="icon-img-updated" />
                    Edit
                  </li>
                  <li
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "5px 10px",
                      border: "none",
                    }}
                    onClick={() => handleAction("manage-seo", row)}
                  >
                    <FiEdit style={{ marginRight: "12px" }} className="icon-img-updated" />
                    Manage SEO
                  </li>
                  <li
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "5px 10px",
                      border: "none",
                    }}
                    onClick={() => handleAction("delete", row)}
                  >
                    <RiDeleteBin6Line style={{ marginRight: "12px" }} className="icon-img-updated" />
                    Delete
                  </li>
                </ul>
              </div>
            )}
          </div>
        ),
      minWidth: "100px",
      maxWidth: "125px",
    },
  ];

  /* --- Applies the Title / Published Date / Status filters against the Blogs API --- */
  const handleFilters = () => {
    const hasFilters =
      searchTitle ||
      status ||
      (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]);

    if (!hasFilters) {
      let warningMessage = "Kindly select or enter respective filtration value...";
      setToastMessage(warningMessage);
      setShowMessage(true);
      return;
    }

    console.log("Selected Filters:", {
      searchTitle,
      status,
      dateRange,
    });

    setFilterLoading(true);
    setFiltersApplied(true);
    setFiltersModified(false);

    if (currentPage !== 1) {
      setCurrentPage(1);
    } else {
      fetchBlogsData(1);
    }
  };

  useEffect(() => {
    if (filtersApplied && filtersModified) {
      handleFilters();

      setFiltersModified(false);
    }
  }, [searchTitle, status, dateRange, filtersApplied, filtersModified]);

  const handleFilterChange = (value, fieldName) => {
    if (fieldName === "searchTitle") {
      setSearchTitle(value);
    } else if (fieldName === "status") {
      setStatus(value);
    } else if (fieldName === "date") {
      setDateRange(value);
    }
    setFiltersModified(true);
  };

  const handleResetFilters = () => {
    setSearchTitle("");
    setStatus(null);
    setDateRange(null);
    setFiltersApplied(false);
    setFiltersModified(false);
    setCurrentPage(1);

    // Pass the cleared values explicitly — setSearchTitle/setStatus/setDateRange
    // above haven't committed yet at this point in the function, so reading
    // searchTitle/status/dateRange here would still return their old values.
    fetchBlogsData(1, { searchTitle: "", status: null, dateRange: null });
  };

  const paginatedData = filteredData;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const placeholderRows = Array(7).fill({ uid: "", name: "", image: "" });

  const displayedData = loading ? placeholderRows : paginatedData;

  return (
    <div className="AllOrderPage">
      <div className="Filters-Section">
        <Accordion allowZeroExpanded className="accordion">
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Filters</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <div className="filter-row-01">
                <div className="filter-label">Title</div>
                <div className="filter-label">Published Date</div>
                <div className="filter-label">Status</div>
              </div>

              <div className="filter-row-02">
                <InputField
                  value={searchTitle}
                  name="searchTitle"
                  onChange={(e) =>
                    handleFilterChange(e.target.value, "searchTitle")
                  }
                  placeholder="Search by Blog Title"
                />

                <div className="Order-filter-date-wrapper">
                  <RangePicker
                    format="YYYY-MM-DD"
                    onChange={(dates) => handleFilterChange(dates, "date")}
                    value={dateRange}
                    style={{ width: "100%", height: "clamp(40px, 6vh, 48px)" }}
                    disabledDate={disabledDate}
                  />
                </div>

                <div className="custom-dropdown-wrapper-Filter">
                  <CustomDropdown
                    options={statusOptions}
                    selectedOption={status}
                    handleOptionChange={(value) =>
                      handleFilterChange(value, "status")
                    }
                    dropdownWidth={'100%'}
                    dropdownMarginBottom="13px"
                    backgroundColor="var(--third-layer-bg)"
                    optionsWidth={'100%'}
                    optionsBackgroundColor="var(--third-layer-bg)"
                    optionsHeight={"auto"}
                    dropdownSelectedStyle="7px"
                  />
                </div>
              </div>

              <div className="filter-row-04">
                {!filtersApplied ? (
                  <CustomBtn
                    label={filterLoading ? <div className="btn-loader-Publish"></div> : "Apply Filters"}
                    withIcon={!filterLoading}
                    iconType="filter"
                    className="FilterBtn-OrderPage"
                    onClick={handleFilters}
                    type="submit"
                  />
                ) : (
                  <>
                    <CustomBtn
                      label="Reset"
                      withIcon={true}
                      iconType="reset"
                      className="ResetBtn-OrderPage"
                      onClick={handleResetFilters}
                      type="button"
                    />
                    <CustomBtn
                      label={filterLoading ? <div className="btn-loader-Publish"></div> : "Apply Filters"}
                      withIcon={!filterLoading}
                      iconType="filter"
                      className="FilterBtn-OrderPage"
                      onClick={handleFilters}
                      type="submit"
                      style={{ backgroundColor: "green" }}
                    />
                  </>
                )}
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>

      <div className="Orders-Table-Data">
        <div>
          <DataTable
            columns={BlogsColumns}
            data={displayedData}
            customStyles={customStyles}
          />
          <ElipticalPagenation
            activePageIndex={currentPage}
            totalPages={totalPages}
            onPrevPage={handlePrevPage}
            onNextPage={handleNextPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>

      {/* --- (PopUp) To Handle Confiramtion for Delete Operation of Single Category --- */}
      {showConfirm && (
        <div className="confirmation-modal">
          <div className="Cat-modal-content" ref={modalRef}>
            <CiWarning className="warning-icon" />
            <div className="Delete-Heading">Warning</div>
            <div className="Delete-Content">
              Are you sure you want to delete this Blog? <br />
              This action cannot be undone.
            </div>
            <div className="separator-line"></div>
            <div className="modal-actions">
              <button
                className="Cat-Delete-btn btn-secondary"
                onClick={cancelDelete}
              >
                Cancel
              </button>

              <div className="SubmitBtn">
                <CustomBtn
                  label={
                    isLoading ? (
                      <div className="btn-loader-Category"></div>
                    ) : (
                      "Confirm"
                    )
                  }
                  className={`Cat-Delete-btn btn-danger ${isActive ? "active" : ""
                    }`}
                  disabled={isLoading}
                  onClick={handleDelete}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <BottomToust
        showMessage={showMessage}
        message={toastMessage}
        handleCloseMessageModal={() => handleCloseMessageModal()}
      />

      <AddBlogSEO
        isOpen={showSeoDrawer}
        onClose={() => setShowSeoDrawer(false)}
        onSave={(updatedMeta) => {
          setMetaData((prev) => ({ ...prev, ...updatedMeta }));
          setShowSeoDrawer(false);
          fetchBlogsData(currentPage);  
        }}
        initialData={metaData}
        blogId={selectedRow?._id}
        mainBlog={{
          image: selectedRow?.image?.image_url ? `${Url}${selectedRow?.image?.image_url}` : null,
          title: selectedRow?.title,
          author: selectedRow?.author,
          status: selectedRow?.status,
        }}
        selectedOgImage={""}
        selectedXImage={""}
        onOpenImagePicker={
          // (type) => handleGalleryModalOpen(type)
          () => { }
        }
        onCancelOgImage={""}
        onCancelXImage={""}
        Url={Url}
      />

    </div>
  );
};

export default AllBlogs;